












































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import VueRouter from 'vue-router'
import GlobalMixin, {ALERT_TYPE} from '@/mixins/globalMixin'
import { BadgeStateModule } from '@/store/modules/BadgeStateModule'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import CustomerSelectDialogComponent from '@/components/CustomerSelectDialogComponent.vue'
import DateAndUserPickerDialogComponent from '@/components/DateAndUserPickerDialogComponent.vue'
import PdfViewComponent from '@/components/PdfViewComponent.vue'
import { Request } from '@/domain/Request'
import { User } from '@/domain/User'
import { WindowPosition } from '@/domain/WindowPosition'
import UninspectedsService, { SerchConditon } from '@/service/UninspectedsService'
import BadgeService from '@/service/BadgeService'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
    CustomerSelectDialogComponent,
    DateAndUserPickerDialogComponent,
    PdfViewComponent,
  },
})
export default class MemberUninspectedList extends Mixins(GlobalMixin) {
  uninspectedsService = UninspectedsService.instance
  badgeService = BadgeService.instance

  /** 検索条件 */
  conditions = new SerchConditon()
  /** データテーブル ヘッダー設定 */
  searchFilter = ""
  headers = [
          { text: "受付番号", value: "requestNo", width: "130px" },
          { text: "顧客名", value: "customerInfo.customerName", width: "240px" },
          { text: "検体名", value: "specimenName", width: "180px" },
          { text: "検体識別記号", value: "specimenId", width: "130px" },
          { text: "検査項目", value: "sumInfo.inspectionNames" },
          { text: "検査分類", value: "sumInfo.classificationNames", width: "130px" },
          { text: "着日", value: "receiptOn", width: "150px" },
          { text: "納品予定日", value: "deliveryOn", width: "110px" },
          { text: "操作", value: "actions", filterable: false, sortable: false, width: "50px" },
  ]
  list: Request[] = []
  selectItems: Request[] = []
  rowItemKey = ""
  rowItemClickTime = 0
  customerName = ""

  itemKey = ""

  /**
   * 選択リストのバリデーション
   */
  get isValidate() {
    return this.selectItems.length > 0
  }

  /**
   * 初期実行
   */
  mounted() {
    /* 初期検索 */  
    const conditions = sessionStorage.getItem("tool.uninspected.list.conditions")
    if (conditions !== null) {
      this.conditions = JSON.parse(conditions) as SerchConditon
    }
    const searchFilter = sessionStorage.getItem("tool.uninspected.list.searchFilter")
    if (searchFilter !== null) {
      this.searchFilter = searchFilter
    }
    this.search()
  }

  /**
   * 検索処理
   */
  search() {
    this.showLoading()
    sessionStorage.setItem("tool.uninspected.list.conditions", JSON.stringify(this.conditions))
    this.uninspectedsService.findAll(this.conditions)
      .then(x => {
        this.list = x
        this.selectItems = []
        /* バッジ情報を取得 */
        this.badgeService.info()
          .then(x => {
            BadgeStateModule.setBadge(x)
          })
          .catch(error => {
            // eslint-disable-next-line
            console.log(error)
          })
        this.mountedDataTable("tool.uninspected.list")
        this.hideLoading()
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("検索エラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }

  /**
   * フィルター処理
   */
  // eslint-disable-next-line
  customFilter(value: any, search: string | null, item: Request): boolean {
    return this.filterCompare(search, item.filterKeyword)
  }

  /**
   * 行クリック時の処理
   */
  onClickRow(event: Request) {
    const now = (new Date()).getTime()
    if ((now - this.rowItemClickTime) <= 500 && this.rowItemKey === event.requestNo) {
      this.onStartInspection(event.requestNo)
    }
    this.rowItemKey = event.requestNo
    this.rowItemClickTime = now
  }

  /**
   * 検査開始日入力
   */
  // eslint-disable-next-line
  onStartInspection(requestNo: string) {
    this.itemKey = requestNo
    this.dateAndUserPickerDialog = true;
  }

  /**
   * 検査開始日入力
   */
  onStartInspections() {
    this.itemKey = this.selectItems.map(x => x.requestNo).join(",")
    this.dateAndUserPickerDialog = true;
  }

  /**
   * 検査開始日実施入力
   */
  onDateAndUserPicker(event: [string, string, User]) {
    this.showLoading()
    const requestNos = event[0].split(",")
    const param = {inspectionOn: event[1], inspectionUserId: event[2].userId, inspectionUserName: event[2].userName}
    this.uninspectedsService.updateInspectOn(requestNos, param)
      .then(() => {
        this.alert("検査開始日を登録しました", ALERT_TYPE.SUCCESS)
        this.search()
        this.hideLoading()
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("検査開始日の登録に失敗しました", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }

  /**
   * フィルター変更
   */
  @Watch("searchFilter")
  changeSearchFilter() {
    sessionStorage.setItem("tool.uninspected.list.searchFilter", this.searchFilter)
  }

  /**
   * 画面を遷移する前の状態保存
   */
  // eslint-disable-next-line
  beforeRouteLeave(to: VueRouter, from: VueRouter, next: any) {
    sessionStorage.setItem("tool.uninspected.list.dataTableOptions", JSON.stringify(this.dataTableOptions))
    sessionStorage.setItem("tool.uninspected.list.windowPosition", JSON.stringify(WindowPosition.now()))
    next()
  }
}
